import { render, staticRenderFns } from "./elTableWithPagination.vue?vue&type=template&id=2a7cab90&"
import script from "./elTableWithPagination.vue?vue&type=script&lang=js&"
export * from "./elTableWithPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports